import { APP_CONFIG } from "./appConfig";

export const APP_KIND = APP_CONFIG.kind;

const envApiBase = import.meta.env.VITE_API_BASE;
export const API_BASE_URL =
  envApiBase !== undefined && envApiBase !== ""
    ? envApiBase
    : import.meta.env.MODE === "development"
      ? APP_CONFIG.devApiBaseUrl
      : APP_CONFIG.prodApiBaseUrl;

const envV2ApiBase = import.meta.env.VITE_V2_API_BASE;
const V2_API_BASE_URL =
  envV2ApiBase !== undefined && envV2ApiBase !== ""
    ? envV2ApiBase
    : import.meta.env.MODE === "development"
    ? APP_CONFIG.devV2ApiBaseUrl || API_BASE_URL
    : APP_CONFIG.prodV2ApiBaseUrl || API_BASE_URL;

const configuredAuthApiVersion = import.meta.env.VITE_AUTH_API_VERSION;
export const AUTH_API_VERSION =
  configuredAuthApiVersion !== undefined && configuredAuthApiVersion !== ""
    ? configuredAuthApiVersion
    : "v2";

export const AUTH_API_BASE_URL =
  AUTH_API_VERSION === "legacy"
    ? API_BASE_URL
    : `${V2_API_BASE_URL}/${AUTH_API_VERSION}`;

export const AUTH_TOKEN_PATH =
  AUTH_API_VERSION === "legacy" ? "/login" : "/auth/token";
export const AUTH_REFRESH_PATH =
  AUTH_API_VERSION === "legacy" ? "/refresh" : "/auth/refresh";
export const AUTH_ME_PATH = AUTH_API_VERSION === "legacy" ? "/me" : "/auth/me";

export const API_V2_BASE_URL = `${V2_API_BASE_URL}/v2`;
export const API_V3_BASE_URL = `${V2_API_BASE_URL}/v3`;
export const V2_AUTH_API_BASE_URL = `${V2_API_BASE_URL}/v2`;
export const V2_AUTH_TOKEN_PATH = "/auth/token";
export const V2_AUTH_REFRESH_PATH = "/auth/refresh";
export const V2_AUTH_ME_PATH = "/auth/me";

const envStoragePrefix = import.meta.env.VITE_APP_STORAGE_PREFIX;

export const STORAGE_PREFIX =
  envStoragePrefix !== undefined ? envStoragePrefix : APP_CONFIG.storagePrefix;

export const getApiAssetUrl = (path) => `${API_BASE_URL}${path}`;
